import { Selector } from "@reduxjs/toolkit";

import { Manifest } from "../manifest/types";
import { ModulFState } from "../store";

import { AssigneeCandidate } from "./types";

export function getUsersForFV(
	manifest: Manifest | undefined
): Selector<ModulFState, readonly AssigneeCandidate[] | undefined> {
	return state => (manifest ? state.users.availableUsers?.[manifest.identification.key] : undefined);
}
